<template>
  <div>
    <el-row :gutter="10">
      <el-col :md="18" class="form-group">
        <el-card class="box-card">
          <zee-searchbar :existing-search-query="searchQuery"></zee-searchbar>
        </el-card>
      </el-col>
      <el-col :md="6" class="form-group">
        <el-card class="box-card">
          <zee-create-new-po></zee-create-new-po>
        </el-card>
      </el-col>
    </el-row>
    <el-row :gutter="10">
      <el-col :md="7" class="form-group">
        <el-card class="box-card">
          <zee-po-list-filter :selected-filters="getFilterSelected"></zee-po-list-filter>
        </el-card>
      </el-col>
      <el-col :md="9" class="form-group">
        <el-card class="box-card">
          <zee-po-by-end-date></zee-po-by-end-date>
        </el-card>
      </el-col>
      <el-col :md="8" class="form-group">
        <el-card class="box-card">
          <zee-po-list-actions></zee-po-list-actions>
        </el-card>
      </el-col>
    </el-row>
    <el-row>
      <zee-po-list></zee-po-list>
    </el-row>
  </div>
</template>

<script>
import * as types from "@/store/mutation-types";
import { mapGetters } from "vuex";
import zeeCreatePo from "./partials/CreatePo.vue";
import zeePoListFilter from "./partials/PoListFilter.vue";
import zeePoListActions from "./partials/PoListActions.vue";
import zeePoList from "./partials/PoList.vue";
import zeeSearchbar from "./partials/Searchbar.vue";
import zeePoByEndDate from "./partials/PoByEndDate.vue";

export default {
  components: {
    zeeCreateNewPo: zeeCreatePo,
    zeePoListFilter,
    zeePoListActions,
    zeePoList,
    zeeSearchbar,
    zeePoByEndDate
  },
  data() {
    return {
      searchQuery: "",
      filterSelected: [],
      isPo: true
    };
  },
  computed: {
    ...mapGetters({
      getSearchQueryString: "getSearchQueryString",
      getSearchQuery: "getSearchQuery",
      getFilterSelected: "getFilterSelected",
      isPOFirstLoad: "isPOFirstLoad",
      isZeenow: "isZeenow"
    })
  },
  beforeMount() {
    document.querySelector("body").className = "is-po";
  },
  created() {
    // set initial search query
    this.$store.commit(types.SET_IS_PO, this.isPo);
    const searchQueryPayments = this.getSearchQuery.replace("q=", "");
    this.searchQuery = searchQueryPayments;
    if (this.isPOFirstLoad) {
      this.$store.dispatch("getSearchedPOData");
      this.$store.commit(types.SET_IS_PO_FIRST_LOAD, false);
    }
  }
};
</script>
<style lang="scss" scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>




// WEBPACK FOOTER //
// src/components/purchase-orders/PurchaseOrders.vue